import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface FiltreRapport {
  debut?: string;          // ISO date-time
  fin?: string;
  zoneId?: number | null;
  typeEnvoi?: string | null;
  livreurId?: number | null;
  granularite?: 'JOUR' | 'SEMAINE' | 'MOIS' | 'TRIMESTRE' | 'SEMESTRE' | 'ANNEE';
  priorite?: string | null;
  motCle?: string | null;
  noteMax?: number | null;
  typeIncident?: string | null;
  typePartenaire?: 'LIVREUR' | 'CENTRE_TRI_DEPART' | 'CENTRE_TRI_ARRIVEE';
}

@Injectable({ providedIn: 'root' })
export class RapportsService {
  private base = `${environment.apiurl}rapports`;

  constructor(private http: HttpClient) {}

  private params(f: FiltreRapport): HttpParams {
    let p = new HttpParams();
    if (f.debut)         p = p.set('debut', f.debut);
    if (f.fin)           p = p.set('fin', f.fin);
    if (f.zoneId != null) p = p.set('zoneId', String(f.zoneId));
    if (f.typeEnvoi)     p = p.set('typeEnvoi', f.typeEnvoi);
    if (f.livreurId != null) p = p.set('livreurId', String(f.livreurId));
    if (f.granularite)   p = p.set('granularite', f.granularite);
    if (f.priorite)      p = p.set('priorite', f.priorite);
    if (f.motCle)        p = p.set('motCle', f.motCle);
    if (f.noteMax != null) p = p.set('noteMax', String(f.noteMax));
    if (f.typeIncident)  p = p.set('typeIncident', f.typeIncident);
    if (f.typePartenaire) p = p.set('typePartenaire', f.typePartenaire);
    return p;
  }

  // Qualité
  erreursAcheminement(f: FiltreRapport): Observable<any> { return this.http.get(`${this.base}/qualite/erreurs-acheminement`, { params: this.params(f) }); }
  pertesVols(f: FiltreRapport): Observable<any>         { return this.http.get(`${this.base}/qualite/pertes-vols`,          { params: this.params(f) }); }
  colisEndommages(f: FiltreRapport): Observable<any>    { return this.http.get(`${this.base}/qualite/colis-endommages`,     { params: this.params(f) }); }
  tauxReclamations(f: FiltreRapport): Observable<any>   { return this.http.get(`${this.base}/qualite/taux-reclamations`,    { params: this.params(f) }); }

  // Satisfaction
  satisfactionNoteMoyenne(f: FiltreRapport): Observable<any> { return this.http.get(`${this.base}/satisfaction/note-moyenne`,   { params: this.params(f) }); }
  retoursClients(f: FiltreRapport): Observable<any>           { return this.http.get(`${this.base}/satisfaction/retours-clients`, { params: this.params(f) }); }

  // Finance
  coutMoyen(f: FiltreRapport): Observable<any>           { return this.http.get(`${this.base}/finance/cout-moyen`,           { params: this.params(f) }); }
  coutAnomalies(f: FiltreRapport): Observable<any>       { return this.http.get(`${this.base}/finance/cout-anomalies`,       { params: this.params(f) }); }
  rentabiliteClients(f: FiltreRapport): Observable<any>  { return this.http.get(`${this.base}/finance/rentabilite-clients`,  { params: this.params(f) }); }
  dashboardFinancier(f: FiltreRapport): Observable<any>  { return this.http.get(`${this.base}/finance/dashboard`,            { params: this.params(f) }); }

  // Volumes & partenaires
  volumeTotal(f: FiltreRapport): Observable<any>          { return this.http.get(`${this.base}/volumes/total`,           { params: this.params(f) }); }
  volumeParType(f: FiltreRapport): Observable<any>        { return this.http.get(`${this.base}/volumes/par-type`,        { params: this.params(f) }); }
  picsVolumes(f: FiltreRapport): Observable<any>          { return this.http.get(`${this.base}/volumes/pics`,            { params: this.params(f) }); }
  evolutionVolumes(f: FiltreRapport): Observable<any>     { return this.http.get(`${this.base}/volumes/evolution`,       { params: this.params(f) }); }
  evolutionDelais(f: FiltreRapport): Observable<any>      { return this.http.get(`${this.base}/delais/evolution`,        { params: this.params(f) }); }
  evolutionReclamations(f: FiltreRapport): Observable<any>{ return this.http.get(`${this.base}/reclamations/evolution`,  { params: this.params(f) }); }
  fiabilitePartenaires(f: FiltreRapport): Observable<any> { return this.http.get(`${this.base}/partenaires/fiabilite`,   { params: this.params(f) }); }
  erreursPartenaires(f: FiltreRapport): Observable<any>   { return this.http.get(`${this.base}/partenaires/erreurs`,     { params: this.params(f) }); }
}
